module.exports = __webpack_public_path__ + "static/media/forkknife.aae36e2f.svg";